// Se definen los types para que no haya errores de tipeo
export const ON_SET_USER_INFO = 'ON_SET_USER_INFO';
export const ON_RESTABLECER_USER_INFO = 'ON_RESTABLECER_USER_INFO';
export const ON_LOGOUT = 'ON_LOGOUT';